(function() {
  'use strict';

  angular
    .module('iqxCore')
    .service('consultantListSvc', consultantListSvc)

  function consultantListSvc(ApiSvc, $q){
    var svc = this
    svc.get = get

    ///////////

    function get(){
      var deferred = $q.defer(),
      fetchScope = {}

      ApiSvc.fetch(fetchScope, {fetchAPI:'callresult/NetOwnerConsultantList',fetchTarget:'consultantList',multiRow:true})
      .then(function(){
        deferred.resolve(fetchScope.consultantList)
      })
      return deferred.promise
    }

  }

})()